export default "__VITE_ASSET__CbxHnagP__"